// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__37Cuw","insightsList":"newBusinessInsightsMenu_insightsList__25Ky2","active":"newBusinessInsightsMenu_active__2EukF"};